import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import axios from 'axios';
import OrganiserAccordion from '../../../organiser/OrganiserAccordion/OrganiserAccordion';

Vue.use(VueFormGenerator);

export default {

  name: 'StepFour',

  components: {
    'organiser-accordion': OrganiserAccordion
  },

  inject: [
    'currentLocale',
    'removeFromCart',
    'storageData',
    'stepValidation',
    'sendConfirmation',
    'bookOrder',
    'sendOrder',
    'getEventByUuid',
    'currentStep'
  ],

  data () {
    return {
      isStepValid: false,
      organiser: {},
      organiserList: [],
      isPackageTravel: {},
      hasMultiplePersons: {},
      formOptions: {
        validateAfterChanged: true
      },
      formData: {},
      OrganiserIsVisible: false
    };
  },

  computed: {

    defaultParticipantFormData: function () {
      return this.storageData.forms.stepTwo[Object.keys(this.storageData.forms.stepTwo)[0]].participantData;
    },

    defaultBillingFormData: function () {
      return this.storageData.forms.stepTwo[Object.keys(this.storageData.forms.stepTwo)[0]].billingAddress;
    },

    schemaAGB: function () {
      let schemaAGB = {};
      for (let uuid in this.organiserList) {
        let AGBText = 'Ich stimme den <a href="' + this.organiserList[uuid].agb + '" target="_blank">Reisebedingungen</a> des Reiseveranstalters ' + this.organiserList[uuid].title + ' zu. *';
        if (this.currentLocale() === 'en') {
          AGBText = 'I accept the <a href="' + this.organiserList[uuid].agb + '" target="_blank">General Terms and Conditions</a> of ' + this.organiserList[uuid].title + '. *';
        }

        schemaAGB[this.organiserList[uuid].uuid] = {
          styleClasses: '',
          fields: [
            {
              type: 'Checkbox',
              model: 'readAGB',
              id: this.organiserList[uuid].uuid + 'readAGB',
              required: true,
              hint: AGBText,
              validator: function (value) {
                if (value !== true) {
                  return this.$options.filters.trans('Bitte stimmen Sie zu.');
                }
              }
            }]
        };
      }

      return schemaAGB;
    },

    schemaEmail: function () {
      let schemaEmail = {};
      for (let uuid in this.organiserList) {
        let emailText = 'Ich bestätige, dass Sie mir alle Unterlagen per E-Mail zukommen lassen dürfen.';
        if (this.currentLocale() === 'en') {
          emailText = 'I hereby confirm, that the ' + this.organiserList[uuid].title + ' is allowed to send me all documents via e-mail.';
        }
        schemaEmail[this.organiserList[uuid].uuid] = {
          styleClasses: '',
          fields: [
            {
              type: 'Checkbox',
              model: 'perMail',
              id: this.organiserList[uuid].uuid + 'perMail',
              required: false,
              hint: emailText,
              validators: VueFormGenerator.validators.required
            }]
        };
      }

      return schemaEmail;
    },

    schemaAccompanying: function () {
      let schemaAccompanying = {};
      for (let uuid in this.organiserList) {
        let accompaningText = 'Ich bestätige, dass ich für die vertraglichen Verpflichtungen von Mitreisenden, für die ich die Buchung vornehme, wie für meine eigenen hafte. *';
        if (this.currentLocale() === 'en') {
          accompaningText = 'I confirm to accept full liability in relation to any and all contractual obligations of any fellow travellers, for and on behalf of whom this booking is made, in the same way as for my own contractual obligations. *';
        }
        schemaAccompanying[this.organiserList[uuid].uuid] = {
          styleClasses: '',
          fields: [
            {
              type: 'Checkbox',
              model: 'readAccompanyingPersons',
              id: this.organiserList[uuid].uuid + 'readAccompanyingPersons',
              required: true,
              hint: accompaningText,
              validator: function (value) {
                if (value !== true) {
                  return this.$options.filters.trans('Bitte stimmen Sie zu.');
                }
              }
            }]
        };
      }

      return schemaAccompanying;
    },

    schemaFilmingPermit: function () {
      let schemaFilmingPermit = {};
      for (let uuid in this.organiserList) {
        let filmText = 'Ich stimme der <a href="' + this.organiserList[uuid].filmingPermit + '" target="_blank">Dreh- und Fotogenehmigung</a> zu.';
        if (this.currentLocale() === 'en') {
          filmText = 'I consent to the <a href="' + this.organiserList[uuid].filmingPermit + '" target="_blank">permission to shoot photos and videos</a>.';
        }
        schemaFilmingPermit[this.organiserList[uuid].uuid] = {
          styleClasses: '',
          fields: [
            {
              type: 'Checkbox',
              model: 'agreedFilmingPermit',
              id: this.organiserList[uuid].uuid + 'agreedFilmingPermit',
              required: false,
              hint: filmText,
              validators: VueFormGenerator.validators.required
            }]
        };
      }

      return schemaFilmingPermit;
    }
  },

  methods: {

    computeVariables: function () {
      let proxy = this;
      let allOrganiser = [];
      let packageTravel = {};
      let multiplePersons = {};
      for (let uuid in this.storageData.cart) {
        let event = this.getEventByUuid(uuid);
        let selectedVarieties = this.storageData.cart[uuid].selectedVarieties;
        let organiser = event.organiser;
        let allowAdd = true;
        allOrganiser.forEach(function (org) {
          if (org.uuid === organiser.uuid) {
            allowAdd = false;
          }
        });
        if (allowAdd) {
          allOrganiser.push(organiser);
        }

        let travelType = event.travelType;
        if (travelType === 'packageTravel') {
          packageTravel[organiser.uuid] = true;
        } else if (packageTravel[organiser.uuid] !== true) {
          packageTravel[organiser.uuid] = false;
        }

        for (let variety in selectedVarieties) {
          if ((variety == 'driver' && selectedVarieties[variety].amount > 1) || (variety == 'driver' && selectedVarieties[variety].eventHasVariety.variety.neededSeats > 1) || (variety == 'accompanyingPerson' && selectedVarieties[variety].amount > 0)) {
            multiplePersons[organiser.uuid] = true;
          } else if (multiplePersons[organiser.uuid] !== true) {
            multiplePersons[organiser.uuid] = false;
          }
        }
      }

      this.organiserList = allOrganiser;
      this.isPackageTravel = packageTravel;
      this.hasMultiplePersons = multiplePersons;
    },

    onValidated (isValid, errors) {
      if (!isValid) {
        this.isStepValid = false;
        Vue.set(this.stepValidation, 'triedToValidateStep', true);
      }
    },

    validateStep: function () {
      this.isStepValid = true;
      Vue.set(this.stepValidation, 'isStepLoading', true);
      let proxy = this;
      this.$refs.toValidateForms.forEach(function (form) {
        // trigger onValidated
        form.validate();
      });
      if (this.isStepValid === true) {
        this.bookOrder().then(function (responseData) {
          if (responseData.hasOwnProperty('status') && responseData.hasOwnProperty('bookingUuid')) {
            if (responseData.status === 'success') {
              proxy.sendOrderMails(responseData.bookingUuid);
              proxy.sendConfirmationMail(responseData.bookingUuid);

              Vue.set(proxy.stepValidation, 'isValid', true);
              Vue.set(proxy.stepValidation, 'isStepLoading', false);
              proxy.$parent.currentStep = proxy.$parent.currentStep + 1;
            } else {
              console.error('BOOKING ERROR', responseData);
            }
          }
        });
      } else {
        Vue.set(proxy.stepValidation, 'isStepLoading', false);
      }

      Vue.set(this.stepValidation, 'isValid', false);
    },

    removeCustomerFromCart: function (customer) {
      for (let uuid in this.storageData.cart) {
        let event = this.getEventByUuid(uuid);
        if (customer.uuid === event.organiser.uuid) {
          this.removeFromCart(event.uuid);
        }
      }
    },

    sendConfirmationMail: function (bookingUuid) {
      let participantContents = document.getElementsByClassName('participant');
      let emails = [];
      emails[0] = this.defaultParticipantFormData.eMail;
      for (let i = 0; i < participantContents.length; i++) {
        emails[i + 1] = participantContents[i].getAttribute('data-email');
      }
      this.sendConfirmation(emails, bookingUuid);
    },

    sendOrderMails: function (bookingUuid) {
      let eventUuids = [];
      let emailContents = [];
      let divContents = document.getElementsByClassName('mail-content');
      for (let i = 0; i < divContents.length; i++) {
        eventUuids[i] = divContents[i].getAttribute('data-event');
        emailContents[i] = divContents[i].innerHTML;
      }
      this.sendOrder(bookingUuid, eventUuids, emailContents);
    }

  },

  created () {
    this.$parent.$off('validateCurrentStep').$on('validateCurrentStep', this.validateStep);
    Vue.set(this.stepValidation, 'isValid', false);
  },

  mounted () {
    this.computeVariables();
    for (let uuid in this.organiserList) {
      let organiser = this.organiserList[uuid];
      if (!this.storageData.forms.stepFour.hasOwnProperty(organiser.uuid)) {
        Vue.set(this.storageData.forms.stepFour, organiser.uuid, {
          'perMail': false,
          'readAGB': false,
          'agreedFilmingPermit': false
        });
      }
    }
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/bookingSteps/defaultSteps/4/StepFour.js